import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export type KidValidationPayload = {
    accountNumber?: string;
    KIDNumber?: string;
};

export const validateKidService = async (
    apiKey: string,
    apiProxyPath: string,
    KIDNumber?: string,
    accountNumber?: string,
    authenticationData?: AuthenticationData,
): Promise<boolean> => {
    const payload: KidValidationPayload = { accountNumber, KIDNumber };
    const response = await apiClient<{ status: string }>(`${apiProxyPath}/validation/kid`, {
        method: 'POST',
        body: payload,
        apiKey,
        authenticationData,
        sentryTag: 'validate_kid',
    });
    return response.status === 'SUCCESS';
};
